module.exports = __webpack_public_path__ + "img/contact_banner.33406e60.png";